import { PropsWithChildren } from 'react';
import styles from './Overlay.module.css';

function Overlay({
  onClick,
  children,
  zIndex,
}: PropsWithChildren<{
  onClick: (event: any) => void
  // eslint-disable-next-line react/require-default-props
  zIndex?: number;
}>) {
  return (
    <div className={styles.container} contentEditable={false}>
      <div role="none" className={styles.overlay} onClick={onClick} />
      {children}
    </div>
  );
}

export default Overlay;
